import React from 'react';
import styled from 'styled-components';

const ModalFooterWrapper = styled.div`
  padding: 15px 30px 20px;
`;

const FlexBox = styled.div`
  display: flex;
  width: max-content;
  margin: 0 auto;
`;

type ButtonAreaProps = {
  $btnCnt: number;
};

const ButtonArea = styled.div<ButtonAreaProps>`
  width: ${(props) => `${100 / props.$btnCnt}%`};
  margin: 0 20px;
  text-align: center;
`;

type Props = {
  buttons?: JSX.Element[];
  aboveButtons?: JSX.Element;
  underButtons?: JSX.Element;
};

const ModalFooter: React.FC<Props> = ({ buttons, aboveButtons, underButtons }): JSX.Element => (
  <ModalFooterWrapper data-testid="uiParts-modalFooter">
    {aboveButtons}
    <FlexBox>
      {buttons &&
        buttons.map((button, i) => (
          <ButtonArea $btnCnt={buttons.length} key={i}>
            {button}
          </ButtonArea>
        ))}
    </FlexBox>
    {underButtons}
  </ModalFooterWrapper>
);

export default ModalFooter;
